export const payment = {
  'seo.title': 'Book Consultation — Prices and Programs | Sofia and Elena',
  'seo.description': 'Choose a nutritional support program: VIP support from €500, FMD protocol €35, child nutrition €400, group intensives €250.',
  'seo.keywords': 'ernæringsfysiolog priser, konsultasjonskostnad, bestill ernæringsfysiolog',

  'hero.title': 'Velg din vei til helse',
  'hero.description': 'Hvert program er en individuell tilnærming og omsorg fra to eksperter',

  'popularChoice': 'Populært valg',

  'service1.title': 'VIP-støtte',
  'service1.duration': '1 måned',
  'service1.price': '€500',
  'service1.feature1': 'Daglig chat-støtte',
  'service1.feature2': 'Analysegjennomgang',
  'service1.feature3': 'Individuell måltidsplan',
  'service1.feature4': 'Stressarbeid',
  'service1.feature5': 'Konsultasjoner med to eksperter',

  'service2.title': 'VIP-støtte',
  'service2.duration': '2 måneder',
  'service2.price': '€900',
  'service2.feature1': 'Alt fra 1 måneds pakke',
  'service2.feature2': 'Dyp transformasjon',
  'service2.feature3': 'Arbeid med familieernæring',
  'service2.feature4': 'Protokolljustering',
  'service2.feature5': 'Maksimalt resultat',

  'service3.title': 'FMD-protokoll',
  'service3.duration': '10 dager',
  'service3.price': '€35',
  'service3.feature1': 'Cellulær foryngelse',
  'service3.feature2': 'Detaljert 10-dagers plan',
  'service3.feature3': 'Daglig støtte',
  'service3.feature4': 'Kropps-biohacking',
  'service3.feature5': 'Vitenskapelig tilnærming',

  'service4.title': 'Barneernæring',
  'service4.duration': 'Individuelt',
  'service4.price': '€400',
  'service4.feature1': 'Arbeid med allergier',
  'service4.feature2': 'Forming av spisevaner',
  'service4.feature3': 'Styrking av immunitet',
  'service4.feature4': 'Plan for hele familien',
  'service4.feature5': 'Foreldrestøtte',

  'service5.title': 'Gruppeintensiv',
  'service5.duration': '3-4 personer',
  'service5.price': '€190',
  'service5.feature1': 'Fellesskapsenergi',
  'service5.feature2': 'Milde protokoller',
  'service5.feature3': 'Gruppestøtte',
  'service5.feature4': 'Rask start',
  'service5.feature5': 'Rimelig pris',

  'service6.title': 'Selvguidet pakke',
  'service6.duration': 'Engangsservice',
  'service6.price': '€150',
  'service6.feature1': 'Detaljert analysegjennomgang',
  'service6.feature2': 'Mangelanbefalinger',
  'service6.feature3': 'Handlings- og ernæringsplan',
  'service6.feature4': 'Ekspertkonsultasjon en gang hver 10. dag',

  'selected': 'Valgt',
  'select': 'Velg',
  'selectServiceAria': 'Velg {{service}}',

  'form.title': 'Bestill konsultasjon',
  'form.description': 'Fyll ut skjemaet, så kontakter vi deg innen 24 timer',
  'form.name.label': 'Ditt navn',
  'form.name.placeholder': 'Skriv inn navnet ditt',
  'form.email.label': 'E-post',
  'form.email.placeholder': 'din@epost.com',
  'form.phone.label': 'Telefon',
  'form.phone.placeholder': '+47 ___ __ ___',
  'form.service.label': 'Velg tjeneste',
  'form.service.placeholder': 'Velg tjeneste',
  'form.message.label': 'Melding',
  'form.message.placeholder': 'Fortell oss om dine mål og ønsker (opptil 500 tegn)',
  'form.message.characters': 'tegn',
  'form.submit': 'Send forespørsel',
  'form.submitting': 'Sender...',
  'form.successMessage': 'Takk! Din forespørsel er sendt. Vi kontakter deg snart.',
  'form.errorMessage': 'En feil oppstod. Vennligst prøv igjen eller kontakt oss direkte.',

  'cta.title': 'Usikker på hvilket program som passer deg?',
  'cta.description': 'Meld deg på en gratis diagnostisk konsultasjon, så hjelper vi deg med å velge den optimale veien',
  'cta.button': 'Bestill gratis konsultasjon',
  'cta.buttonAria': 'Bestill en gratis konsultasjon',
};